export const hasPermission = (permissions, moduleName, actionName, screenName = null) => {
  if (!permissions || typeof permissions !== "object") {
    return false
  }

  if (Object.keys(permissions).length === 0) {
    return false
  }

  const module = permissions[moduleName]
  if (!module?.permission_settings) {
    return false
  }

  const screen = screenName || `${moduleName}_main`
  const permissionScreen = module.permission_settings[screen]

  if (!permissionScreen?.actions) {
    return false
  }

  const action = permissionScreen.actions[actionName]
  return action?.active === true
}

export const hasAnyPermission = (permissions, checks) => {
  if (!Array.isArray(checks) || checks.length === 0) {
    return false
  }

  return checks.some((check) => {
    const { module, action, screen } = check
    return hasPermission(permissions, module, action, screen)
  })
}

export const hasAllPermissions = (permissions, checks) => {
  if (!Array.isArray(checks) || checks.length === 0) {
    return false
  }

  return checks.every((check) => {
    const { module, action, screen } = check
    return hasPermission(permissions, module, action, screen)
  })
}

export const getPermissionScope = (permissions, moduleName, actionName, screenName = null) => {
  if (!permissions || typeof permissions !== "object") {
    return []
  }

  const module = permissions[moduleName]
  if (!module?.permission_settings) {
    return []
  }

  const screen = screenName || `${moduleName}_main`
  const permissionScreen = module.permission_settings[screen]

  if (!permissionScreen?.actions) {
    return []
  }

  const action = permissionScreen.actions[actionName]
  return action?.scope || []
}

export const hasModuleAccess = (permissions, moduleName, screenName = null) => {
  if (!permissions || typeof permissions !== "object") {
    return false
  }

  const module = permissions[moduleName]
  if (!module?.permission_settings) {
    return false
  }

  const screen = screenName || `${moduleName}_main`
  const permissionScreen = module.permission_settings[screen]

  if (!permissionScreen?.actions) {
    return false
  }

  return Object.values(permissionScreen.actions).some((action) => action?.active === true)
}

export const getActivePermissions = (permissions, moduleName, screenName = null) => {
  if (!permissions || typeof permissions !== "object") {
    return []
  }

  const module = permissions[moduleName]
  if (!module?.permission_settings) {
    return []
  }

  const screen = screenName || `${moduleName}_main`
  const permissionScreen = module.permission_settings[screen]

  if (!permissionScreen?.actions) {
    return []
  }

  return Object.keys(permissionScreen.actions).filter((actionName) => permissionScreen.actions[actionName]?.active === true)
}

export const hasFullAccess = (activeProfile) => {
  return activeProfile?.has_full_access === true || activeProfile?.profile_role === "admin"
}

export const MODULES = {
  BOOKINGS: "bookings",
  CALENDAR: "calendar",
  CLIENTS: "clients",
  MESSAGES: "messages",
  GALLERY: "gallery",
  MARKETING: "marketing",
  ACCOUNTING: "accounting",
  CREW: "crew",
  STAFF: "crew",
  EQUIPMENT: "equipment",
  EXPERIENCES: "experiences",
  RENTALS: "rentals",
  SETTINGS: "settings"
}

export const ACTIONS = {
  VIEW: "view",
  CREATE: "create",
  EDIT: "edit",
  DELETE: "delete",
  DISABLE: "disable",
  DEACTIVATE: "deactivate",
  IMPORT: "import",
  FULL_ACCESS: "full_access",
  VIEW_JOURNAL: "view_journal",
  CREATE_JOURNAL: "create_journal",
  EDIT_JOURNAL: "edit_journal",
  DELETE_JOURNAL: "delete_journal"
}
